import { createAction } from '@reduxjs/toolkit';

// Actions
export const previewFile = createAction<{
  fileId: string;
}>('[file] preview file');
